import en from "./en.json";
import it from "./it.json";

const category = { it, en };

export default category;
